import useSnackbarStore from '@/store/snackbar';
import { getApiErrorMessage } from '@/utils/getApiErrorMessage';

/**
 * api:
 * This function is used to handle fetching data from the server
 * It takes the request and the options for the fetch
 * It returns the data and the error
 *
 * Using $fetch to make network requests based on user interaction.
 *
 * @param {NitroFetchRequest} request: The request to fetch the data
 * @param {NitroFetchOptions} opts: The options for the fetch
 * @returns {pending, data, error, execute}
 */
export default defineNuxtPlugin(() => {
  const snackbar = useSnackbarStore();
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.set('Content-Type', 'application/json; charset=utf-8');

  const $api = $fetch.create({
    baseURL: useRuntimeConfig().public.apiUrl,
    headers: {
      Accept: 'application/json',
    },
    onRequest({ request, options, error }) {
      const accessToken = useCookie(
        useRuntimeConfig().public.auth?.provider?.token?.cookieName ||
          'accessToken'
      );
      const skipAuth = Boolean((options as { skipAuth?: boolean }).skipAuth);
      if (accessToken.value && !skipAuth) {
        options.headers = new Headers(options.headers || {});
        options.headers.set('Authorization', `Bearer ${accessToken.value}`);
      }
    },
    async onResponseError({ response, options }) {
      if (options?.showSnackbar) {
        const payload = response._data as { message?: string } | undefined;
        const text =
          getApiErrorMessage({ data: payload }) ||
          payload?.message ||
          'Request failed';
        snackbar.showSnackbar({
          text,
          state: false,
        });
      }
    },
  });

  return {
    provide: {
      api: $api,
    },
  };
});
